import { push } from 'store/navigation/actions';
import { call, put, select } from 'redux-saga/effects';
import routes from 'routes';
import {
  fetchMeRequest,
  loginFailure,
  loginMfa,
  loginSuccess,
  logoutRequest,
  setThirdPartySSO,
} from '../actions';
import { login, LoginResponse } from '../api';
import { LoginRequestAction } from '../types';
import { ApiError } from 'store/api/types';
//import { RememberUser } from '../utils/rememberUser';
import { checkResponse } from 'store/utils';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { getThirdPartySSO } from '../selectors';
import { renderErrorMessage } from 'utils/render-error-message';
import { clearGenTaxCalledPage } from 'utils/check-page-loaded';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* loginSaga(action: LoginRequestAction) {
  try {
    let err: ApiError | null;
    const { loginParams, rememberMe, gCaptchaResponse, mfaCode } =
      action.payload;
    const response: LoginResponse = yield call(
      // @ts-ignore
      login,
      loginParams,
      gCaptchaResponse,
      !mfaCode ? null : mfaCode
    );
    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const mfaResponse = response?.data;
    if (mfaResponse?.useMFA) {
      yield put(loginMfa(mfaResponse));
    } else {
      clearGenTaxCalledPage();
      yield put(loginSuccess());
      yield put(push(routes.main));

      // if (rememberMe) RememberUser.save(loginParams);
      // else RememberUser.clear();
      const thirdPartySSO = yield select(getThirdPartySSO);
      if (thirdPartySSO) {
        localStorage.setItem('thirdPartySSO', JSON.stringify(thirdPartySSO));
      }

      yield put(fetchMeRequest());
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(loginFailure());
  }
}
